import { Outlet } from 'react-router-dom';
import { CreativeWorkbenchProvider } from './CreativeWorkbenchContext';
import { CommandPalette } from './CommandPalette';

function CreativeWorkbenchLayoutInner() {
  return (
    <div data-testid="creative-workbench-shell" className="space-y-4">
      <CommandPalette />
      <div className="pt-2">
        <Outlet />
      </div>
    </div>
  );
}

export function CreativeWorkbenchLayout() {
  return (
    <CreativeWorkbenchProvider>
      <CreativeWorkbenchLayoutInner />
    </CreativeWorkbenchProvider>
  );
}
